import { useEffect } from "react";

const SectionBackgroundVideo = () => {
  useEffect(() => {}, []);

  return (
    <div className="absolute inset-0 w-full h-full -z-10x">
      <video
        id="video-bg"
        src="https://ik.imagekit.io/4apzi8lz0/egarizim/egarizim_Q3VPvdB4.mp4?updatedAt=1760896566635"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
        className="w-full h-full object-cover opacity-40"
      >
        <track kind="captions" src="data:text/vtt,WEBVTT" label="Français" default />
      </video>
    </div>
  );
};

export default SectionBackgroundVideo;
